import React, { useState, useRef, useCallback, RefObject } from "react";
import { Grid, useMediaQuery } from "@material-ui/core";
import DropZone from "./DropZonev2";
import UploadFileButtons from "./UploadFileButtons";
import useStyles from "./useStyles";
import Webcam from "react-webcam";
import MobileWebcam from "./MobileWebcam";

export interface FileProps {
    preview?: string;
    file?: File | Blob;
}

export interface VideoConstraintsProps {
    width: string;
    height: string;
    facingMode: "user";
}

export interface UploadFileProps {
    // Callback chamado quando o usuário faz o upload do arquivo
    handleOnUploadFile?: () => Promise<void>;

    // Callback chamado quando o usuário seleciona um arquivo para fazer uplaod
    handleOnChangeSelectedFile?: (file: FileProps) => void;

    handleOpenCamera?: () => void;

    handleCloseCamera?: () => void;
    // SelectedFile possuí o arquivo selecionado para upload. Caso undefined, usuário ainda não selecionou um arquivo
    selectedFile?: FileProps;

    // True se usuário estiver utilizando a câmera
    cameraRecording?: boolean;
}

const videoConstraints = {
    width: 320,
    height: 200,
    facingMode: "user",
};

const UploadFile: React.FC<UploadFileProps> = ({
    handleOnChangeSelectedFile,
    handleOnUploadFile,
    handleCloseCamera,
    handleOpenCamera,
    selectedFile,
    cameraRecording,
}) => {
    const webcamRef = useRef(null);
    const cellphoneScreen = useMediaQuery("(max-width:460px)");

    const onCapture = React.useCallback(
        (webcanRef: RefObject<Webcam> = webcamRef) => {
            const imageSrc = webcanRef.current.getScreenshot();
            handleOnChangeSelectedFile({
                file: convertDataURLToBlob(imageSrc),
                preview: imageSrc,
            });
            handleCloseCamera();
        },
        [webcamRef]
    );

    const convertDataURLToBlob = (dataurl) => {
        var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    function createFileObject(file: File) {
        return {
            file,
            preview: URL.createObjectURL(file),
            uploaded: false,
        } as FileProps;
    }
    function onSelectFile(file: File) {
        handleOnChangeSelectedFile(createFileObject(file));
    }

    function renderCamera() {
        return (
            <Webcam
                ref={webcamRef}
                videoConstraints={videoConstraints}
                audio={false}
                screenshotFormat="image/jpeg"
            />
        );
    }

    const handleOnCancelUploadFile = () => {
        handleOnChangeSelectedFile(undefined);
    };

    function renderImageIfSelectedImage() {
        return <img style={{ height: "240px" }} src={selectedFile.preview} />;
    }

    return (
        <div>
            <Grid container spacing={2} alignItems={"center"} justify="center">
                <Grid item md={6} sm={12} xs={12}>
                    {cellphoneScreen && !selectedFile ? null : (
                        <DropZone
                            imageConstrant={{
                                height: videoConstraints.height,
                                width: videoConstraints.width,
                            }}
                            onDropFile={onSelectFile}
                            contentComponet={
                                cameraRecording
                                    ? renderCamera()
                                    : selectedFile
                                    ? renderImageIfSelectedImage()
                                    : undefined
                            }
                        />
                    )}
                </Grid>
                {cameraRecording && cellphoneScreen ? (
                    <Grid item xs={12}>
                        <MobileWebcam
                            handleOnCapture={onCapture}
                            onCancel={() => handleCloseCamera()}
                        />
                    </Grid>
                ) : (
                    <Grid item md={6} sm={12} xs={12}>
                        <UploadFileButtons
                            {...{
                                cameraRecording,
                                handleCloseCamera,
                                handleOpenCamera,
                                onCapture,
                                onSelectFile,
                                handleOnCancelUploadFile,
                                hasFileSelected: selectedFile ? true : false,
                                onUploadFile: handleOnUploadFile,
                            }}
                        />
                    </Grid>
                )}
            </Grid>
        </div>
    );
};

export default UploadFile;
